import React from "react";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


import Grid from '@mui/material/Grid';
import StdButton from './stdbutton.jsx';

class UserForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: true,
            user: Object.assign({},props.user.data),
            email: props.user.data.email
        };
        this.userFormRef = React.createRef();
        this.setState = this.setState.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlock = this.handleBlock.bind(this);

        this.renderBody = this.renderBody.bind(this);
        this.changeData = this.changeData.bind(this);
    }

    componentDidMount() {
    }

    static getDerivedStateFromProps(props, state) {
        if ((props.user.data.email || state.email) && props.user.data.email!=state.email) {
            let newState = {
                error: null,
                isLoaded: true,
                user: Object.assign({}, props.user.data),
                email: props.user.data.email
            };
            return newState;
        } else {
            return null;
        }
    }

    changeData(e){
        let user = this.state.user;
        user[e.target.name]=e.target.value;
        this.setState({ user: user });
    }

    handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(this.userFormRef.current);
        let email = null;
        if (!this.props.user.isNew) {
            data.append("email", this.props.user.data.email);
            email = encodeURIComponent(this.props.user.data.email);
        }
        saveItem("/web/users", email, data, this.props.onSaveResult);
    }

    handleBlock(e) {
        e.preventDefault();
        let email = encodeURIComponent(this.props.user.data.email);
        patchItem("/web/users", email, { "blocked": !this.state.user.blocked }, this.props.onSaveResult);
    }

    render() {
             return (
                <Dialog
                    open={this.props.open}
                    onClose={this.props.onClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        { this.props.user.isNew ? (
                            <span>Add user</span>
                        ) : (
                            <span>Edit user</span>
                        ) }
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ minWidth: 550 }}>
                            { this.props.user.error && (
                                <div>{this.props.user.error}</div>
                            )}
                        {this.renderBody()}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={12} style={{ padding: 20 }}>
                                {this.props.user.isNew ? (
                                    <span/>
                                ):(
                                <StdButton label={ this.state.user.blocked ? 'Activate user':'Deactivate user' } onClick={this.handleBlock}/>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} style={{ padding: 20, textAlign: "right" }}>
                                <StdButton label="Cancel" onClick={this.props.onClose}/>
                                <StdButton label="Save" type="alt" onClick={this.handleSubmit}/>
                            </Grid>
                        </Grid>

                    </DialogActions>
                </Dialog>

            )
        }

        renderBody(){
            if (this.props.user.error) {
                return <div>Error: {this.props.user.error.message}</div>;
            } else if (!this.props.user.isLoaded) {
                return <div className="text-center" ><div className="spinner-border m-5" /></div>;
            } else {

                var fieldErrors = (this.props.user.fieldErrors) ? this.props.user.fieldErrors:{};
                return (
                    <form className="form-horizontal" ref={this.userFormRef}>

                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>

                                <TextField
                                    id="email" name="email" label="Email" error={(fieldErrors['email']) ? true:false} helperText={fieldErrors['email']}
                                    value={this.state.user.email} onChange={this.changeData} disabled={!this.props.user.isNew}
                                    margin="dense" variant="outlined" fullWidth />

                            </Grid>
                            <Grid item xs={6} sm={6}>

                                <TextField
                                    id="firstName" name="firstName" label="First name" error={(fieldErrors['firstName']) ? true:false} helperText={fieldErrors['firstName']}
                                    value={this.state.user.firstName} onChange={this.changeData}
                                    margin="dense" variant="outlined" fullWidth />

                            </Grid>
                            <Grid item xs={6} sm={6}>

                                <TextField
                                    id="lastName" name="lastName" label="Last name" error={(fieldErrors['lastName']) ? true:false} helperText={fieldErrors['lastName']}
                                    value={this.state.user.lastName} onChange={this.changeData}
                                    margin="dense" variant="outlined" fullWidth />

                            </Grid>
                            <Grid item xs={12} sm={12}>

                                <FormControl variant="outlined" fullWidth margin="dense">
                                    <InputLabel htmlFor="outlined-role">
                                        Role
                                    </InputLabel>
                                    <Select name="role" id="role" value={this.state.user.role?this.state.user.role:""} onChange={this.changeData}
                                            input={<OutlinedInput name="role" id="outlined-role" />}>
                                        <MenuItem value="operator">operator</MenuItem>
                                        <MenuItem value="expert">expert</MenuItem>
                                        <MenuItem value="administrator">administrator</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>

                        </Grid>
                    </form>
                );
            }
        }

}


export default UserForm;